module.exports = __webpack_public_path__ + "static/img/product_images_02.7ceb8be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/chataxera/product_images_02.png
// module id = yUYG
// module chunks = 34